<template>
  <div class="">
    <t-dropdown variant="smActions">
      <template
        v-slot:trigger="{
          mousedownHandler,
          focusHandler,
          blurHandler,
          keydownHandler,
        }"
      >
        <button
          class="text-oDark focus:outline-none"
          aria-label="Report Status Menu"
          aria-haspopup="true"
          @mousedown="mousedownHandler"
          @focus="focusHandler"
          @blur="blurHandler"
          @keydown="keydownHandler"
        >
          <svg
            class="mt-1 w-6 h-5 text-oGray hover:text-oDark"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
            ></path>
          </svg>
        </button>
      </template>

      <template v-slot:default="{ hide }">
        <div
          @click="hide()"
          class="py-1 mt-px bg-white rounded-md shadow-md z-200"
        >
          <t-dropdown-item variant="danger" @click="askConfirmation">
            Delete
          </t-dropdown-item>
        </div>
      </template>
    </t-dropdown>

    <ConfirmFirst
      :id="`confirmFirst-${data.id}`"
      :key="`confirmFirst-${data.id}`"
      :isLoading="isLoading"
      :title="`Delete Country (${data.name})?`"
      :confirmButtonText="`Delete`"
      :confirmButtonVariant="`warning-alt`"
      @confirm="executeAction('delete')"
      @cancel="handleCancellation"
    />
  </div>
</template>

<script>
import { CountriesConfig } from '@/config/CountriesConfig'
export default {
  name: 'CurrenciesMoreActionsDropdown',
  components: {
    TDropdownItem: () => import('@/components/dropdown/TDropdownItem'),
    ConfirmFirst: () => import('@/components/modals/ConfirmFirst'),
  },
  props: {
    data: {
      type: Object,
      required: false,
      default() {
        return {
          status: false,
        }
      },
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    askConfirmation() {
      this.$modal.show(`confirmFirst-${this.data.id}`)
    },
    async executeAction(type) {
      if (type === 'delete') {
        const endpoint = CountriesConfig.api.delete(this.data.id)

        this.isLoading = true
        await this.$http
          .delete(endpoint)
          .then((res) => {
            console.log('delete', res.data)
            this.$emit('delete', res.data)
            this.$modal.hide(`confirmFirst-${this.data.id}`)
          })
          .catch((err) => {
            console.error(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    handleCancellation() {
      console.log('cancelled')
    },
  },
}
</script>

<style lang="scss" scoped></style>
